export const GET_AUTH_SUCCESS = 'GET_AUTH_SUCCESS';
export const GET_AUTH_FAILURE = 'GET_AUTH_FAILURE';
export const CLEAN_AUTH = 'CLEAN_AUTH';
export const AUTH_INIT_STATE = null;
